import React from 'react';
import './MySquareIcon.css';

function MySquareIcon({ color, icon: Icon, onClick }) {
    return (
        <div 
            className="my-square" 
            style={{ backgroundColor: color }} 
            onClick={onClick}
        >
            <span className="my-square-symbol">
                <Icon size={24} color="white" />
            </span>
        </div>
    );
}

export default MySquareIcon;